<template>
  <div>
    <draggable v-if="type === 'list'" ghost-class="ghost" :list="arrayImage">
      <transition-group type="transition" name="list-complete">      
        <div v-for="(img, index) in arrayImage" :key="index" class="custom-img pa-1">
          <div class="thumb cursor-move" :style="`background-image: url(${isObject(img)})`"></div>
          <div class="url cursor-move">{{getImageName(isObject(img))}}</div>
          <DeleteButton @click="handleDeleteImage(index)"/>
        </div>
      </transition-group>
    </draggable>

    <div v-if="type === 'thumb'" class="thumb-container">
      <draggable 
        ghost-class="ghost" 
        class="d-flex flex-row flex-wrap"
        style="gap: 20px"
        :list="arrayImage" 
      >
        <div v-for="(img, index) in arrayImage" :key="index" class="thumb-style cursor-move" :style="`background-image: url(${isObject(img)})`">
          <div class="delete-btn">
            <DeleteButton @click="handleDeleteImage(index)"/>
          </div>
        </div>
      </draggable>  
    </div>
    
    <div class="custom-img-btn pt-3">
      <input
        ref="uploader"
        class="d-none"
        type="file"
        name="photo"
        accept="image/*"
        :multiple="multiple"
        @change="onFileChanged"
      />            
      <Button 
        label="Upload de imagem" 
        color="bt_gray_bg"
        textColor="darkBlue"
        textSize="0.80rem"
        icon="fa-solid fa-upload"
        @click="handleUpload"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import Button from '../ui/Button.vue'
import DeleteButton from '../ui/DeleteButton.vue'

export default {
  name: 'MultipleUploadImage',
  components: {Button, DeleteButton, draggable},
  props: {
    value: {type: Array}, // Can be an array of strings or array of objects, in this case you need to use keyValue.
    keyValue: {type: String},
    type: {type: String, default: 'list'}, // list or thumb
    multiple: {type: Boolean, default: false}
  },

  computed: {
    ...mapGetters(['infos']),
    arrayImage: {
      get () { return this.value },
      set (v) { 
        this.$emit('input', v)
      }      
    }
  },

  methods: {
    isObject (value) {
      if (typeof value === 'object') return value[this.keyValue]
      else return value
    },

    handleUpload () {
      this.$refs.uploader.click()
    },

    handleDeleteImage (index) {
      this.arrayImage.splice(index, 1)
    },

    getImageName (url) {
      return url.split('/').pop() || ''
    },    

    async onFileChanged(event) {
      const { files } = event.target

      const promisesUpload = []
      const uploadImage = (file) => {
        const formData = new FormData()
        formData.append('media', file)
        formData.append("hotsiteId", this.infos["organizer-id"])

        return this.$store.dispatch("setImage", {formData: formData, token: this.$route.params.token})
          .then(uploadedImg => uploadedImg.url)
      }

      files.forEach(file => { promisesUpload.push(uploadImage(file))})

      try {
        const imagesUploaded = await Promise.all(promisesUpload)

        if (this.keyValue) this.arrayImage = [...this.arrayImage, ...imagesUploaded.map(image => ({[this.keyValue]: image}))]
        else this.arrayImage = [...this.arrayImage, ...imagesUploaded.map(image => image)]   
      } catch (e) {
        console.log(e)
      }
    }     
  }
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
  cursor: move !important;
}

/* Transition Group  */
.list-complete-item {
  transition: all 0.8s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.list-complete-leave-active {
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
}

/* Modo Lista  */
.custom-img {
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s  
}

.custom-img:hover {
  background-color: #F6F7F7;
  border-radius: 8px;
}

.custom-img-btn button {
  width: 100% !important;
  transition: all 0.3s
}

.custom-img-btn button:hover {
  background-color: #CBCBCE !important;
}

.custom-img .thumb {
  min-width: 40px;
  min-height: 40px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid #EDEDF1;
}

.custom-img .url {
  flex: 1;
  overflow: hidden;
  direction: rtl; 
  font-size: 0.9rem
}

.custom-img .delete {
  display: flex;
  justify-content: end;
  min-width: 50px;
}

.cursor-move {
  cursor: move !important;
}

/* Modo Thumb  */
.thumb-container {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 4px;
}

.thumb-style {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 8px;
  background-color: #EDEDF1;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid #EDEDF1; 
  transition: all 0.3s   
}

.thumb-style::before {
  content: '';
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0);
  transition: background-color 0.3s;
}

.thumb-style:hover::before {
  background-color: rgba(255, 255, 255, 0.5);
}

.delete-btn {
  position: absolute;
  z-index: 10;
  top: 2px !important;
  right: 2px !important;
  transform: scale(0.8);
}
</style>